<template>
    <div class="page">
	    <div class="page-text-wrap">
		    <h1>Campingpladser</h1>
		    <img src="@/assets/info/camping.jpg" class="img-responsive">
		    <p>I uge 29 stiger efterspørgslen på campingpladser i Vorbasse eksplosivt. Vores DCU Camping, har slet ikke pladser nok.</p>
		    <p>Derfor har vi 2 store campingpladser med i alt 800 pladser.</p>
		    <p>Vores campingpladser er delt på to forskellige steder. Spejdercamping og Vorbasse Markedscamping". På en del af pladserne har man mulighed for tilslutning til strøm.
			    Der er altid plads til en hyggelig fest, men jo senere det bliver, jo mere er vi til stille guitar end larmende SoundBox. På vores campingpladser bor alle aldre side om side, så derfor viser vi hensyn til hinanden.
			    Vidste du i øvrigt, at har du haft en plads på camping et år, får du samme plads tilbudt året efter helt automatisk?</p>
		    <p><strong>Vil du med næste år?</strong><br>Så husk at du kan booke plads fra 1. april 2021.</p>
		    <img src="@/assets/info/camping.jpg" class="img-responsive">
	    </div>
    </div>
	
	
</template>

<script>
	export default {
		name: "Camping.vue"
	}
</script>
